import React, { useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import ESGStandards from "./ESGStandards";
import "./StandardTemplate.scss";
import StdTemplateConfigPane from "./StdTemplateConfigPane";
import StdTemplateDSLinkingPane from "./StdTemplateDSLinkingPane";

function StdTemplateConfigContainer({ t }) {

	const { stdId } = useParams();
  const [searchParams] = useSearchParams(); 
  const stdName = searchParams.get('name') ?? '';
  const [esgData, setEsgData] = useState([]);
  const [dsLinkParams, setDSLinkParams] = useState({});
  const [dataUpdatedOn, setDataUpdatedOn] = useState({ date: 0 });

  return (
    <>
      <div className='TopicsAdminNew'>
        <div className="List_header pb-2">
          <Breadcrumb className="h5 m-0">
            <Breadcrumb.Item href="#">{t("Configurations.label")}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t("Standards.label")}</Breadcrumb.Item>
            <Breadcrumb.Item active>{stdName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="New_StandardTopic_matricCard">
          <div className="row m-0">
            <div className="col-lg-6 p-2">
              <StdTemplateConfigPane esgData={esgData} 
                onOpenDSLink={(p) => setDSLinkParams(p)}
                onSaveCallback={() => {
                  setEsgData([]);
                  setDataUpdatedOn({ date: Date.now() });
                }}
                linkSavedOn={dataUpdatedOn}/>
            </div>
            <div className="col-lg-6 p-2">
              {
                (dsLinkParams.metricId > 0 || dsLinkParams.dpId > 0)
                ?
                <StdTemplateDSLinkingPane params={dsLinkParams} standardId={stdId}
                  onClose={() => setDSLinkParams({})}
                  onSaveCallback={() => {
                    setDataUpdatedOn({ date: Date.now(), params: dsLinkParams });
                    setDSLinkParams({});
                  }}/>
                :
                <ESGStandards isConfigMode={true} 
                  onAdd={(d) => {
                    let newTopics = JSON.parse(JSON.stringify(esgData));
                    d?.forEach(esgTopic => {
                      const matchingTopicIndex = newTopics?.findIndex(t => t.id === esgTopic.id);
                      if (matchingTopicIndex >= 0) {
                        esgTopic.metrics?.forEach(esgMetric => {
                          const matchingMetricIndex = newTopics[matchingTopicIndex]?.metrics?.findIndex(m => m.id === esgMetric.id);
                          if (matchingMetricIndex < 0) {
                            newTopics[matchingTopicIndex].metrics.push(esgMetric);
                          }
                        });
                      } else {
                        newTopics.push(esgTopic);
                      }
                    });
                    setEsgData(newTopics);
                  }}
                  selectedDataClearedOn={dataUpdatedOn.date}/>
              }              
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default withTranslation()(StdTemplateConfigContainer);
